import { render, staticRenderFns } from "./djfxDialog.vue?vue&type=template&id=0078b9a4&scoped=true"
import script from "./djfxDialog.vue?vue&type=script&lang=js"
export * from "./djfxDialog.vue?vue&type=script&lang=js"
import style0 from "./djfxDialog.vue?vue&type=style&index=0&id=0078b9a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0078b9a4",
  null
  
)

export default component.exports